export const ButtonColors = {
  orange: 'orange',
  green: 'green',
  gray: 'gray',
  lightGray: 'light-gray',
  green500: 'green-500',
};
